export const modules = [
  "Data Admin",
  "Data Karyawan",
  "Data Mitra",
  "Data Komisi",
  "Transaksi Singkong",
  "Verifikasi Singkong",
  "Manajemen Akses",
  "User Setup",
];
